// extracted by mini-css-extract-plugin
export var flowchartContainer = "_u-0";